import { Row, Col } from "react-bootstrap";

function ViewerItem(props) {
  const width = props.width ? props.width : 6;
  return props.value ? (
    <Col xs={12} md={width} lg={width} xl={width}>
      <Row>
        <Col className="headings" xs={6} sm={6} md={6} lg={5} xl={5}>
          {props.title}
        </Col>

        <Col xs={6} sm={6} md={6} lg={7} xl={7}>
          <span id={props.id} className={props.className}>
            {props.value}
          </span>
        </Col>
      </Row>
    </Col>
  ) : (
    <></>
  );
}

export default ViewerItem;
